module.exports = __webpack_public_path__ + "static/img/bind.0e3e47d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/bind.png
// module id = yCWJ
// module chunks = 0